var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:{hideSidebar:!_vm.sidebar.opened}},[_c('layout-left'),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('layout-header'),_vm._v(" "),_c('layout-center'),_vm._v(" "),_c('layout-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac4ffd2a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layouts/Layout.vue
// module id = 1172
// module chunks = 0